import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f45ad79"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "name", "type"]
const _hoisted_2 = ["for"]

import {watch, ref} from 'vue'
    
    interface IProps {
        attrId:string
        attrName:string
        inputType:string
    }
    
export default /*#__PURE__*/_defineComponent({
  __name: 'AttributeButton',
  props: {
    attrId: {},
    attrName: {},
    inputType: {}
  },
  emits: ['changedAttr'],
  setup(__props: any, { emit }) {

const props = __props;

    
    

    watch(props, () => {
            let elements:any = ref(document.querySelectorAll(`input[name="${props.attrName}"]`))
            if (elements.value == null) return
            for(let element of elements.value){
                element.checked = false
            }
            emit('changedAttr')
        }, { deep: true })
    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("input", {
      class: _normalizeClass(props.attrName),
      id: props.attrId,
      name: props.attrName,
      type: _ctx.inputType,
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    }, null, 10, _hoisted_1),
    _createElementVNode("label", {
      id: "btn-click",
      class: "menu-button-container",
      for: props.attrId
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 8, _hoisted_2)
  ], 64))
}
}

})